export interface IEventListener {
  send: Function
  subscribeListener: Function
  unSubscribeListener: Function
}

const eventChannel = new BroadcastChannel('transfer-data')

export default defineNuxtPlugin((nuxtApp) => {
  const send = (data: any) => eventChannel.postMessage(JSON.stringify(data))
  const subscribeListener = (cb: any) => eventChannel.addEventListener('message', cb, false)
  const unSubscribeListener = (cb: any) => eventChannel.removeEventListener('message', cb, false)
  const eventListener: IEventListener = {
    send,
    subscribeListener,
    unSubscribeListener,
  }
  return {
    provide: {
      eventListener,
    },
  }
})
